import { RiskLevel } from "@/model/RiskLevel";
import { DefaultHigh, DefaultLower, NullBanner } from "@/model/DefaultBanners";
const IncreasingBanner = {
    rawCopy: `For Increasing Risk scores we recommend you cut down your drinking.
 Click here to <u>book a free online appointment</u> with an alcohol specialist.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/20"
};
const HigherBanner = {
    rawCopy: `For Higher Risk scores we recommend you cut down your drinking. Click here to
        <u>book a free online appointment</u> with an alcohol specialist.`,
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/20"
};
export default {
    name: "Haringey",
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: IncreasingBanner,
        [RiskLevel.Higher]: HigherBanner,
        [RiskLevel.High]: DefaultHigh
    },
    clinics: [
        {
            name: "Haringey Recovery Service",
            times: [
                {
                    title: "Appointments:",
                    info: "<br><strong>Due to COVID there is no drop-in service. Please phone to arrange an appointment.</strong> Referrals accepted via email <a href='mailto:harccg.haga@nhs.net'>harccg.haga@nhs.net</a>"
                }
            ],
            address: "590 Seven Sisters Road, London, N15 6HR",
            phone: ["0208 801 3999"],
            location: {
                lat: 51.5773308,
                lng: -0.08289360000003398
            }
        },
        {
            name: "HAGA Alcohol Service",
            description: "Contact ${name}",
            location: { lat: 51.6025827, lng: -0.059929000000011 },
            address: "590 Seven Sisters Road, London, N15 6HR",
            isPrimaryProvider: true,
            phone: ["0208 801 3999"],
            email: "harccg.haga@nhs.net",
            times: [
                {
                    title: "Appointments:",
                    info: "<br><strong>Due to COVID there is no drop-in service. Please phone to arrange an appointment.</strong> Referrals accepted via email <a href='mailto:harccg.haga@nhs.net'>harccg.haga@nhs.net</a><br>",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }],
                        saturday: [{ start: 1000, end: 1500 }]
                    }
                }
            ],
            website: "https://www.haga.co.uk"
        },
        {
            name: "Queenswood Medical Practice",
            location: { lat: 51.5843639, lng: -0.13089939999997569 },
            address: "Park Road, London, N8 8JD",
            website: "http://www.queenswoodmedicalpractice.com/",
            // times: 'Appointments available on Wednesdays, 5pm-7pm  (subject to availability)',
            times: [
                {
                    title: "Appointments:",
                    info: "<br>Due to COVID the alcohol clinics may not be operating as usual, contact 0208 801 3999 or email <a href='mailto:harccg.haga@nhs.net'>harccg.haga@nhs.net</a> for more information",
                    times: {
                        wednesday: [{ start: 1700, end: 1900 }]
                    }
                }
            ],
            email: "harccg.haga@nhs.net",
            info: "Please let us know that you wish to book a GP clinic appointment when you email us."
        },
        {
            name: "Rutland House Surgery",
            location: { lat: 51.5952405, lng: -0.14454320000004373 },
            address: "40 Colney Hatch Lane, Muswell Hill, N10 1DU",
            email: "harccg.haga@nhs.net",
            // times: 'Appointments available 1pm-4pm (subject to availability)',
            times: [
                {
                    title: "Appointments:",
                    info: "<br>Due to COVID the alcohol clinics may not be operating as usual, contact 0208 801 3999 or email <a href='mailto:harccg.haga@nhs.net'>harccg.haga@nhs.net</a> for more information",
                    times: {
                        monday: [{ start: 1300, end: 1600 }],
                        tuesday: [{ start: 1300, end: 1600 }],
                        wednesday: [{ start: 1300, end: 1600 }],
                        thursday: [{ start: 1300, end: 1600 }],
                        friday: [{ start: 1300, end: 1600 }],
                        saturday: [{ start: 1300, end: 1600 }],
                        sunday: [{ start: 1300, end: 1600 }]
                        // TODO(jon): Check weekends?
                    }
                }
            ],
            info: "Please let us know that you wish to book a GP clinic appointment when you email us."
        },
        {
            name: "The Muswell Hill Practice",
            location: { lat: 51.5917809, lng: -0.14165479999996933 },
            address: "1 Dukes Avenue, Muswell Hill, N10 2PS",
            website: "http://www.dukesavenuepractice.co.uk",
            // times: 'Appointments available on Fridays, 4pm-6pm (subject to availability)',
            times: [
                {
                    title: "Appointments:",
                    info: "<br>Due to COVID the alcohol clinics may not be operating as usual, contact 0208 801 3999 or email <a href='mailto:harccg.haga@nhs.net'>harccg.haga@nhs.net</a> for more information",
                    times: {
                        friday: [{ start: 1600, end: 1800 }]
                    }
                }
            ],
            email: "harccg.haga@nhs.net",
            info: "Please let us know that you wish to book a GP clinic appointment when you email us."
        },
        {
            name: "St Ann’s Road Surgery",
            location: { lat: 51.5814016, lng: -0.08772659999999632 },
            address: "The Laurels Healthy Living Centre, 256 St Ann’s Road, London, N15 5AZ",
            // times: 'Appointments available 11am-6.30pm (subject to availability)',
            times: [
                {
                    title: "Appointments:",
                    info: "<br>Due to COVID the alcohol clinics may not be operating as usual, contact 0208 801 3999 or email <a href='mailto:harccg.haga@nhs.net'>harccg.haga@nhs.net</a> for more information",
                    times: {
                        monday: [{ start: 1100, end: 1830 }],
                        tuesday: [{ start: 1100, end: 1830 }],
                        wednesday: [{ start: 1100, end: 1830 }],
                        thursday: [{ start: 1100, end: 1830 }],
                        friday: [{ start: 1100, end: 1830 }]
                    }
                }
            ],
            email: "harccg.haga@nhs.net",
            info: "Please let us know that you wish to book a GP clinic appointment when you email us."
        },
        {
            name: "DrinkCoach Online Coaching",
            showAtRiskLevel: [RiskLevel.Higher, RiskLevel.Increasing],
            tagline: "<a href='https://drinkcoach.bookinglive.com/book/add/p/20' target='_blank'>Book</a> your free sessions with an alcohol specialist.",
            alwaysShowInResults: true,
            website: "https://drinkcoach.org.uk/book-online-appointment"
        }
    ]
};
//# sourceMappingURL=Haringey.js.map